export default __webpack_public_path__ + "static/media/Hurricanes.ec5cb397.png";